import React from 'react';
import { StarIcon } from 'lucide-react';
import { projects } from '../data/projects';
const GLOW_URL = 'https://cdn.magicpatterns.com/uploads/1dtgi7QnsP8byg87sF8xWb/footer.C-44yuQw.jpg';

// Featured review: the real Härtel quote. Reviewer, photo and details come from data/projects.ts (placeholders).
const featured = projects[0];
export function Testimonial() {
  const {
    review,
    authorName,
    avatar,
    clientName,
    details,
    rating
  } = featured;
  return <section aria-label="Kundenstimme" className="relative isolate overflow-hidden bg-[#08070b] text-white" data-id="element-536" data-mp="bec5c0wix2dt">
      {/* Grainy violet light rays rising from the bottom edge, fading into black */}
      <img src={GLOW_URL} alt="" aria-hidden="true" loading="lazy" className="absolute inset-x-0 bottom-0 -z-10 h-[70%] w-full object-cover object-bottom opacity-80 [mask-image:linear-gradient(to_top,black_0%,rgba(0,0,0,0.55)_35%,transparent_100%)]" data-id="element-537" data-mp="1g63fjapvw8y" />
      <img src={GLOW_URL} alt="" aria-hidden="true" loading="lazy" className="absolute inset-x-0 top-0 -z-10 h-[22%] w-full rotate-180 object-cover object-bottom opacity-25 [mask-image:linear-gradient(to_top,black,transparent)]" data-id="element-538" data-mp="3to4fsrgryrbq" />

      <div className="px-4 md:px-6" data-id="element-539" data-mp="9262lx44ixjz">
        <div className="mx-auto max-w-[1360px] border-x border-white/[0.07]" data-id="element-540" data-mp="43lbqoarhq87">
          <figure className="mx-auto flex max-w-[980px] flex-col items-center px-5 py-20 text-center md:py-32" data-id="element-541" data-mp="41iblbfwagpr">
            <div className="flex gap-1" role="img" aria-label={`${rating} von 5 Sternen`} data-id="element-542" data-mp="3ch1zduxsr6xf">
              {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} aria-hidden="true" className={`h-5 w-5 ${i < rating ? 'fill-[#fbbc04] text-[#fbbc04]' : 'fill-white/15 text-white/15'}`} data-id="element-543" data-mp="3ma9ck1ys3r82" data-mpi={i} />)}
            </div>

            <blockquote className="mt-8 font-display text-[30px] font-medium leading-[1.15] tracking-[-0.035em] text-white md:text-[48px]" data-id="element-544" data-mp="2ou3nlakmgn5u">
              „{review}“
            </blockquote>

            <figcaption className="mt-10 flex flex-col items-center gap-4" data-id="element-545" data-mp="xpsd5xc0cg0q">
              <div className="flex items-center gap-3 text-left" data-id="element-546" data-mp="xnnyckcklwlo">
                {avatar ? <img src={avatar} alt={authorName} loading="lazy" className="h-12 w-12 rounded-full object-cover ring-2 ring-white/15" data-id="element-547" data-mp="12haambetnygy" /> : <span aria-hidden="true" className="grid h-12 w-12 place-items-center rounded-full bg-white/10 text-[17px] font-medium text-white" data-id="element-548" data-mp="eq4q3ixxsi0b">
                    {authorName.charAt(0)}
                  </span>}
                <div data-id="element-549" data-mp="1u8g4wb7v31yb">
                  <p className="text-[16px] font-medium leading-tight text-white" data-id="element-550" data-mp="1u6vemxsky569">{authorName}</p>
                  <p className="mt-0.5 text-[14px] leading-tight text-white/55" data-id="element-551" data-mp="1z5gaym4po4pf">{clientName}</p>
                </div>
              </div>

              <ul className="flex flex-wrap items-center justify-center gap-x-2 text-[14px] text-white/50" data-id="element-552" data-mp="29cix7btchv9v">
                {details.map((d, i) => <li key={d} className="flex items-center gap-2" data-id="element-553" data-mp="1zjtryyoe1dmz" data-mpi={i}>
                    {i > 0 && <span aria-hidden="true" className="text-white/25" data-id="element-554" data-mp="1vjtcrbtgsyev">·</span>}
                    {d}
                  </li>)}
              </ul>
            </figcaption>
          </figure>
        </div>
      </div>
    </section>;
}